export const NotificationDataType = {
  BIRTHDAY_REMINDER: 'BIRTHDAY_REMINDER',
  EVENT_CREATED: 'EVENT_CREATED',
  EVENT_UPDATED: 'EVENT_UPDATED',
  EVENT_DELETED: 'EVENT_DELETED',
  EVENT_USER_ATTACHED: 'EVENT_USER_ATTACHED',
  EVENT_USER_DETACHED: 'EVENT_USER_DETACHED',
  HAPPY_BIRTHDAY: 'HAPPY_BIRTHDAY',
  INFO_NEW_CLUB_SIGN_UP: 'INFO_NEW_CLUB_SIGN_UP',
  INVENTORY_ASSIGNED: 'INVENTORY_ASSIGNED',
  INVENTORY_RECEIVED: 'INVENTORY_RECEIVED',
  INVENTORY_PASSED: 'INVENTORY_PASSED',
  INVENTORY_SHOULD_RETURN: 'INVENTORY_SHOULD_RETURN',
  INVENTORY_RETURNED: 'INVENTORY_RETURNED',
  INVENTORY_TRANSFER_CANCELLED: 'INVENTORY_TRANSFER_CANCELLED',
  PASSWORD_RESET: 'PASSWORD_RESET',
  PROSPECTS_GROUP_ASSIGNED: 'PROSPECTS_GROUP_ASSIGNED',
  PROSPECTS_NEW_PROSPECT: 'PROSPECTS_NEW_PROSPECT',
  PROSPECTS_NEW_ADMIN: 'PROSPECTS_NEW_ADMIN',
  REGISTRATION: 'REGISTRATION',
  USER_REGISTRATION: 'USER_REGISTRATION',
  WELCOME: 'WELCOME',
  WELCOME_CLUB: 'WELCOME_CLUB',
  WELCOME_OWN_REGISTRATION: 'WELCOME_OWN_REGISTRATION',
  BASKETBALL_COMMENT_GAME_CREATED: 'BASKETBALL_COMMENT_GAME_CREATED',
  BASKETBALL_COMMENT_PRACTICE_CREATED: 'BASKETBALL_COMMENT_PRACTICE_CREATED',
  BASKETBALL_GAME_TASK_ASSIGNMENT: 'BASKETBALL_GAME_TASK_ASSIGNMENT',
  BASKETBALL_GAME_CREATED: 'BASKETBALL_GAME_CREATED',
  BASKETBALL_GAME_DELETED: 'BASKETBALL_GAME_DELETED',
  BASKETBALL_GAME_UPDATED: 'BASKETBALL_GAME_UPDATED',
  BASKETBALL_GAMES_UPDATED: 'BASKETBALL_GAMES_UPDATED',
  BASKETBALL_LEAGUE_LINKED: 'BASKETBALL_LEAGUE_LINKED',
  BASKETBALL_LEAGUE_UNLINKED: 'BASKETBALL_LEAGUE_UNLINKED',
  BASKETBALL_MESSAGE: 'BASKETBALL_MESSAGE',
  BASKETBALL_PRACTICE_TASK_ASSIGNMENT: 'BASKETBALL_PRACTICE_TASK_ASSIGNMENT',
  BASKETBALL_PRACTICE_CREATED: 'BASKETBALL_PRACTICE_CREATED',
  BASKETBALL_PRACTICE_DELETED: 'BASKETBALL_PRACTICE_DELETED',
  BASKETBALL_PRACTICE_UPDATED: 'BASKETBALL_PRACTICE_UPDATED',
  BASKETBALL_PRACTICES_CREATED: 'BASKETBALL_PRACTICES_CREATED',
  BASKETBALL_PRACTICES_DELETED: 'BASKETBALL_PRACTICES_DELETED',
  BASKETBALL_PRACTICES_UPDATED: 'BASKETBALL_PRACTICES_UPDATED',
  BASKETBALL_PRACTICES_SYNC: 'BASKETBALL_PRACTICES_SYNC',
  BASKETBALL_REFEREE_ASSIGNMENT: 'BASKETBALL_REFEREE_ASSIGNMENT',
  BASKETBALL_REMINDER_CARS: 'BASKETBALL_REMINDER_CARS',
  BASKETBALL_REMINDER_JERSEYS: 'BASKETBALL_REMINDER_JERSEYS',
  BASKETBALL_REMINDER_JUDGE: 'BASKETBALL_REMINDER_JUDGE',
  BASKETBALL_REMINDER_REPLY: 'BASKETBALL_REMINDER_REPLY',
  BASKETBALL_REMINDER_RESPONSIBLE_USER: 'BASKETBALL_REMINDER_RESPONSIBLE_USER',
  BASKETBALL_REMINDER_TASK_ASSIGNMENT: 'BASKETBALL_REMINDER_TASK_ASSIGNMENT',
  BASKETBALL_TEAM_ASSIGNMENT: 'BASKETBALL_TEAM_ASSIGNMENT',
  BASKETBALL_TEAM_JUDGE_ASSIGNMENT: 'BASKETBALL_TEAM_JUDGE_ASSIGNMENT',
  BASKETBALL_TEAM_JUDGE_ASSIGNMENTS: 'BASKETBALL_TEAM_JUDGE_ASSIGNMENTS',
  BASKETBALL_TEAM_TASK_GAME_ASSIGNMENT: 'BASKETBALL_TEAM_TASK_GAME_ASSIGNMENT',
  BASKETBALL_TEAM_TASK_PRACTICE_ASSIGNMENT:
    'BASKETBALL_TEAM_TASK_PRACTICE_ASSIGNMENT',
  BASKETBALL_USER_JERSEYS_ASSIGNMENT: 'BASKETBALL_USER_JERSEYS_ASSIGNMENT',
  BASKETBALL_USER_JUDGE_ASSIGNMENT: 'BASKETBALL_USER_JUDGE_ASSIGNMENT',
  BASKETBALL_USER_JUDGE_ASSIGNMENTS: 'BASKETBALL_USER_JUDGE_ASSIGNMENTS',
  BASKETBALL_USER_RESPONSIBLE_USER_ASSIGNMENT:
    'BASKETBALL_USER_RESPONSIBLE_USER_ASSIGNMENT',
  BASKETBALL_SWITCH_REQUEST: 'BASKETBALL_SWITCH_REQUEST',
};
